import { render, staticRenderFns } from "./Consultation.vue?vue&type=template&id=f4eb2180"
import script from "./Consultation.vue?vue&type=script&lang=js"
export * from "./Consultation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports